(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldTimepicker', fbFieldTimepickerDirective);

    function fbFieldTimepickerDirective($timeout) {
        return {
            restrict: 'EA',
            scope: {
                element:'=',
                model: '='
            },
            templateUrl: 'common/libraries/formBuilder/fields/fieldTimepicker',
            controller: fbFieldTimepickerDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function(scope) {
            }
        };
    }

    function fbFieldTimepickerDirectiveCtrl(lodash, FormBuilderService, $scope) {
        var vm = this;
        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);

            vm.timeOptions = angular.merge({
                    change: function() {
                        //console.log($scope.model);
                        vm.onEventTrigger('onChange');
                    }
                },
                lodash.get(vm.element,'attr.timePickerOptions',{})
            );
        }
    }
})();